import Button from '@artemis/components/Button';
import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-row-gap: 12px;
`;

export const Title = styled.h1`
  ${props => props.theme.typography.h3};
  font-weight: ${props => props.theme.typography.fontWeightBold};
  padding-bottom: 8px;
`;

export const Description = styled.p`
  ${props => props.theme.typography.body};
  ${props =>
    props.$medium && `font-weight: ${props.theme.typography.fontWeightMedium}`};
  color: ${props => props.theme.rtColors.black900};
  margin-bottom: 8px;
  white-space: pre-line;
`;

export const Body = styled.div`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.rtColors.black900};
  ${props =>
    props.$bold && `font-weight: ${props.theme.typography.fontWeightBold};`}
  ${props =>
    props.$medium && `font-weight: ${props.theme.typography.fontWeightMedium};`}
`;

export const Bold = styled.span`
  font-weight: ${props => props.theme.typography.fontWeightBold};
`;

export const List = styled.ul`
  padding: 0;
  margin: 0;
`;

export const ButtonContainer = styled.div`
  display: grid;
  margin: 0;
  padding: 24px 0;
  grid-row-gap: 12px;
  position: sticky;
  bottom: 0;
  background-color: ${props => props.theme.rtColors.background100};
`;

export const SearchContainer = styled.div`
  position: relative;

  > input {
    line-height: 16px;
    background: ${props => props.theme.rtColors.black100};
    border: none;
    border-radius: 8px;
    padding: 12px 52px;
    width: 100%;
    box-sizing: border-box;
  }
`;

export const PrimaryButton = styled(Button).attrs({ buttonType: 'solid' })`
  width: 100%;
`;

export const SecondaryButton = styled(Button).attrs({ buttonType: 'ghost' })`
  width: 100%;
`;

export const LinkButton = styled(Button).attrs({ buttonType: 'link' })`
  width: 100%;
`;
